//

import { get } from 'lodash-es';

import { Loader, Scrollbars } from 'modules/common/components';
import { getPreflightCheckItems } from 'modules/common/utils';
import { CriteriaList } from 'modules/editor/components';
import { MODAL_HEIGHT } from 'modules/publish/constants';

import S from 'modules/publish/styles';

const PreflightView = ({ loading, preflight, onEditCover, onEditSection }) => {
  if (loading) {
    return <Loader height={MODAL_HEIGHT} title="Checking book" />;
  }

  const criteria = get(preflight, 'finalResponse');
  const items = getPreflightCheckItems(criteria);

  const handleEdit = (sectionId) => {
    if (sectionId) {
      onEditSection(sectionId);
    } else {
      onEditCover();
    }
  };

  return (
    <Scrollbars style={{ height: MODAL_HEIGHT }}>
      <S.ViewTitle>Pre-Flight Check!</S.ViewTitle>
      <S.ViewSubTitle>
        We are checking your book and verifying all the essentials. Please use the edit feature to
        clear any pre-flight check errors.
      </S.ViewSubTitle>
      <CriteriaList items={items} onEdit={handleEdit} />
    </Scrollbars>
  );
};

export default PreflightView;
